import { AD_BUTLER_ENDPOINT, ITEM_COUNT_DIVISOR, MAX_CATEGORY_TILES, AD_SET_STYLE_ROTATING } from "./constants.js";
const fetchAdButlerData = async (siteId, setId, adPreviewHash = null, keyword) => {
  var _a;
  const requestParams = [
    // TODO: Will need to figure out which site to get an ID for
    `ID=${siteId}`,
    `setID=${setId}`,
    `type=jsonr`,
    `output_json_template_params=1`
  ];
  if (adPreviewHash) {
    requestParams.push(`_adb_lwp=${adPreviewHash}`);
    requestParams.push(`referrer=${(_a = window == null ? void 0 : window.location) == null ? void 0 : _a.origin}`);
  }
  if (keyword) {
    requestParams.push(`kw=${encodeURIComponent(keyword)}`);
  }
  const response = await fetch(
    `${AD_BUTLER_ENDPOINT};${requestParams.join(";")}`
  );
  return await response.json();
};
const placementItemToAdBuilder = (placement) => {
  const { placement_id, redirect_url, template_params, ad_type } = placement;
  const top_and_bottom_strip = [];
  if (template_params.TopText || template_params.TopBackgroundColor) {
    top_and_bottom_strip.push({
      strip: {
        _metadata: {
          uid: placement_id
        },
        background_color: {
          background_color: {
            hex: template_params.TopBackgroundColor
          },
          background_gradient_color: {
            color1: { hex: template_params.TopGradientColor1 },
            color2: { hex: template_params.TopGradientColor2 }
          },
          background_gradient_style: template_params.TopGradientStyle
        },
        font_size: ad_type === "item_driver" ? "small" : "large",
        strip_type: "top_strip",
        text: template_params.TopText,
        text_color: {
          hex: template_params.TopTextColor
        }
      }
    });
  }
  if (template_params.BottomText || template_params.BottomBackgroundColor) {
    top_and_bottom_strip.push({
      strip: {
        _metadata: {
          uid: placement_id
        },
        background_color: {
          background_color: {
            hex: template_params.BottomBackgroundColor || "none"
          },
          background_gradient_color: {
            color1: { hex: template_params.BottomGradientColor1 },
            color2: { hex: template_params.BottomGradientColor2 }
          },
          background_gradient_style: template_params.BottomGradientStyle || "solid"
        },
        font_size: "small",
        strip_type: "bottom_strip",
        text: template_params.BottomText,
        text_color: {
          hex: template_params.BottomTextColor
        }
      }
    });
  }
  const top_and_bottom_text_banner = [];
  if (template_params.HeadlineText) {
    top_and_bottom_text_banner.push({
      add_text_banner: {
        banner_background_color: {
          background_color: {
            hex: template_params.HeadlineBackgroundColor
          },
          background_gradient_color: {
            color1: {
              hex: template_params.HeadlineBackgroundColor
            },
            color2: {
              hex: template_params.HeadlineBackgroundColor
            }
          },
          background_gradient_style: "solid"
        },
        font_size: "large",
        text: template_params.HeadlineText,
        text_banner_type: "top_banner",
        text_color: {
          hex: template_params.HeadlineColor
        }
      }
    });
  }
  if (template_params.CTAText) {
    top_and_bottom_text_banner.push({
      add_text_banner: {
        banner_background_color: {
          background_color: {
            hex: template_params.CTAColor
          },
          background_gradient_color: {
            color1: {
              hex: template_params.CTAColor
            },
            color2: {
              hex: template_params.CTAColor
            }
          },
          background_gradient_style: "solid"
        },
        font_size: "large",
        text: template_params.CTAText,
        text_banner_type: "bottom_banner",
        text_color: {
          hex: template_params.CTATextColor
        }
      }
    });
  }
  const AD_TYPE_IMAGE_SIZES = {
    item_driver: {
      height: 350,
      type: 0,
      width: 350
    },
    large_ad: {
      height: 425,
      type: 0,
      width: 1054
    },
    large_banner: {
      height: 358,
      type: 0,
      width: 1400
    },
    large_half_banner: {
      height: 571,
      type: 0,
      width: 696
    }
  };
  const MOBILE_AD_IMAGE_SIZE = {
    item_driver: {
      height: 350,
      type: 0,
      width: 350
    },
    large_ad: {
      height: 144,
      type: 0,
      width: 358
    },
    large_banner: {
      height: 571,
      type: 0,
      width: 704
    },
    large_half_banner: {
      height: 239,
      type: 0,
      width: 358
    }
  };
  return {
    ad_type,
    // background_group,
    // caption,
    costco_url: {
      external_site: placement.template_params.ExternalSite === "Yes",
      url: redirect_url
    },
    // disclaimer,
    // enable_caption,
    // enable_custom_background,
    // enable_disclaimer,
    enable_mobile_image_variation: template_params["Mobile Image URL"] || template_params.MobileImageURL ? true : false,
    // enable_product_linked: true,
    image: [
      {
        dimensions: AD_TYPE_IMAGE_SIZES[ad_type],
        url: template_params["Image URL"] || template_params.DesktopImageURL || template_params["Mobile Image URL"] || template_params.MobileImageURL,
        mimetype: "image/jpeg"
      }
    ],
    // enable_sponsored,
    // enable_text_content,
    image_alt_text: template_params.Alt,
    mobile_image: [
      {
        dimensions: MOBILE_AD_IMAGE_SIZE[ad_type],
        url: template_params["Mobile Image URL"] || template_params.MobileImageURL,
        mimetype: "image/jpeg"
      }
    ],
    mobile_image_alt_text: template_params.Alt,
    // product_link,
    // text_content_overlay_styles,
    // text_content_placement,
    // text_content: ,
    top_and_bottom_strip,
    top_and_bottom_text_banner,
    uid: placement_id,
    use_mobile_image_alt_text: !!template_params.Alt
  };
};
const placementToCategoryTiles = (element, clickUrl) => {
  const categoryAds = [];
  const finalKey = Object.keys(element.template_params).filter((key) => key.startsWith("Category")).sort().pop();
  const matches = finalKey == null ? void 0 : finalKey.match(/^Category ([0-9]+)/);
  if (!Array.isArray(matches) || !matches[1]) {
    return [];
  }
  for (let i = 1; i <= +matches[1]; i++) {
    categoryAds.push({
      background: true,
      categoryData: {
        hrefUrl: clickUrl,
        imageUrl: element.template_params[`Category ${i} Image`],
        title: element.template_params[`Category ${i} Title`],
        uid: element.placement_id
      },
      foreground: true
      // heading: element.template_params[`SectionText${i}`]
    });
  }
  return categoryAds;
};
const isRotatingAd = (ad_set_style) => {
  return ad_set_style === AD_SET_STYLE_ROTATING;
};
const normalizeAdobeCategoryData = (adobeCategoryData) => {
  const categoryDisplayProperties = adobeCategoryData ? adobeCategoryData.categoryDisplayProperties : {};
  const freqViewedCats = adobeCategoryData && adobeCategoryData.visitorFavCategories ? adobeCategoryData.visitorFavCategories.split(",") : [];
  let freqViewedCatData = freqViewedCats == null ? void 0 : freqViewedCats.map(
    (freq) => {
      const currentCategory = categoryDisplayProperties[freq];
      return currentCategory && {
        hrefUrl: currentCategory.catURL,
        imageUrl: currentCategory.tileImgSrc,
        title: currentCategory.tileTitle
      };
    }
  );
  const targetCategoryTileCount = freqViewedCatData.length - freqViewedCatData.length % ITEM_COUNT_DIVISOR;
  freqViewedCatData = freqViewedCatData.filter((cat) => {
    return cat !== void 0;
  }).slice(0, Math.min(targetCategoryTileCount, MAX_CATEGORY_TILES));
  return freqViewedCatData;
};
export {
  fetchAdButlerData,
  isRotatingAd,
  normalizeAdobeCategoryData,
  placementItemToAdBuilder,
  placementToCategoryTiles
};
